<template>
	<div class="list-container column">
		<table id="apikeys">
			<thead>
				<tr>
					<th>Namn</th>
					<th style="min-width: 700px;">API-Nyckel</th>
					<th style="max-width: 100px;">Upphör</th>
					<th style="max-width: 30px"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="apiKey in apiKeys" :key="apiKey.id">
					<td style="width: 250px;">{{ apiKey.name }}</td>
					<td style="min-width: 100%">
						<input
							v-if="showApiKeyForKey == apiKey.id"
							class="input-box"
							type="text"
							:value="apiKey.jwtToken"
							readonly
						/>
						<input
							v-if="showApiKeyForKey != apiKey.id"
							class="input-box"
							type="password"
							:value="apiKey.jwtToken"
							readonly
						/>
						<span
							style="float: right;"
							class="icon-style first-icon-style"
							@click.stop="onEdit(apiKey.id)"
						>
							<i class="fas fa-eye"></i>
						</span>
						<span
							style="float: right;"
							class="icon-style first-icon-style"
							@click.stop="copyToClipboard(apiKey.jwtToken)"
						>
							<i class="fas fa-copy"></i>
						</span>
					</td>
					<td style="max-width: 100px;">
						{{ parseExpireDate(apiKey.jwtToken) }}
					</td>
					<td style="max-width: 30px; text-align: center;">
						<span class="icon-style" @click.stop="onDelete(apiKey)">
							<i class="fas fa-trash-alt"></i>
						</span>
					</td>
				</tr>
				<tr></tr>
			</tbody>
		</table>
		<div class="panel-list no-hover" v-if="apiKeys.length == 0">
			<p class="header-item">Inga resultat</p>
		</div>
		<Pagination
			v-if="apiKeys.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';

export default {
	components: {
		Pagination
	},
	data() {
		return {
			keyType: 'password',
			showApiKeyForKey: ''
		};
	},
	props: {
		apiKeys: Array
	},
	computed: {
		...mapGetters('apiKeyStore', ['pagination']),
		...mapGetters('appStore', ['isMobile'])
	},
	methods: {
		...mapActions('apiKeysStore', ['setCurrentPage', 'setPageSize']),
		onDelete(apiKey) {
			this.$emit('delete', apiKey);
		},
		onEdit(id) {
			if (this.showApiKeyForKey === id) {
				this.showApiKeyForKey = '';
			} else {
				this.showApiKeyForKey = id;
			}
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		},
		parseExpireDate(jwt) {
			var decoded = jwtDecode(jwt);
			const expDate = new Date(decoded.exp * 1000);

			return `${expDate.getFullYear()}-${expDate.getMonth() +
        1}-${expDate.getDate()}`;
		},
		copyToClipboard(jwtToken) {
			// Copy the text inside the text field
			navigator.clipboard.writeText(jwtToken);
			// Alert the copied text
			alert('Api-Nyckel kopierad');
		}
	}
};
</script>
<style>
input {
  width: 90%;
  max-width: 700px;
  height: 25px;
  border: none;
  padding: 0px;
  margin: 0px;
  font-size: 8pt;
}

input.input-box,
textarea {
  background: white !important;
}

.icon-style {
  width: 20px;
}

.first-icon-style {
  margin-left: 10px;
}

.expire-date-style {
  margin-left: 10px;
}

#apikeys {
  font-family: Arial, Helvetica, sans-serif;

  width: 100%;
}

#apikeys td,
#apikeys th {
  border: 1px solid #ddd;
  padding: 8px;
}

#apikeys tr:nth-child(even) {
  background-color: white;
}

#apikeys tr:hover {
  background-color: white;
}

#apikeys th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #f5f5f5;
}
</style>
